import BaseCan from "./baseCan";
import User from "../models/user";
import { OrganizationRoleCapability } from "../enums/roles/capabilities/organizationRoleCapability";
import UserDecorator from "../../formability/admin/models/userDecorator";
import Visualization from "../models/visualizations/visualization";
import {DocumentRoleCapability} from "~/enums/roles/capabilities/documentRoleCapability";
import {PeerDocumentRoleCapability} from "~/enums/roles/capabilities/peerDocumentRoleCapability";

export default class VisualizationCan extends BaseCan {
  constructor(user: User | UserDecorator) {
    // Mapping abilities based on object model abilities as of now
    super(user);

    const visualizationClasses = [Visualization];

    this.iCan(
      [
        "manage",
        "edit",
        "viewContextMenu",
        "moveArchive",
        "publish",
      ],
      visualizationClasses,
      visualization => {
        return user.hasOrganizationCapability(
          OrganizationRoleCapability.manageObjectModels
        );
      }
    );

    this.iCan('publishUnpublishVisualization', Visualization, (visualization: Visualization) => {
      return user.hasOrganizationCapability(OrganizationRoleCapability.createEditArchiveAnalytics) || visualization.hasShareCapability(user, DocumentRoleCapability.publishUnpublishAnalytic)
    })

    this.iCan('showVisualization', Visualization, (visualization: Visualization) => {
      const organizationCapabilites = [OrganizationRoleCapability.createEditArchiveAnalytics]
      const documentCapabilities = [DocumentRoleCapability.editAnalytic, DocumentRoleCapability.publishUnpublishAnalytic]
      const peerDocumentCapabilities = [PeerDocumentRoleCapability.viewAnalytic]
      return user.hasOrganizationCapability(organizationCapabilites) || visualization.hasShareCapability(user, documentCapabilities) || visualization.hasShareCapability(user, peerDocumentCapabilities)
    })
  }
}
